import { render, staticRenderFns } from "./ScreeningsUpdateSamples.vue?vue&type=template&id=770e237c&scoped=true&"
import script from "./ScreeningsUpdateSamples.vue?vue&type=script&lang=js&"
export * from "./ScreeningsUpdateSamples.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningsUpdateSamples.vue?vue&type=style&index=0&id=770e237c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770e237c",
  null
  
)

export default component.exports